<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="6">
              <DateSelector
                labelDate="Od"
                :date="startDate"
                @change="updateStartDateTime"
              />
            </v-col>
            <v-col cols="6">
              <DateSelector
                labelDate="Do"
                :date="endDate"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="usersWithNull"
                item-text="name"
                item-value="val"
                v-model="user"
                label="Uporabnik"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="search"
              >
                Išči
                <v-icon right dark>fas fa-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn
                v-if="!loading && reportData.length"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print"
              >
                Tiskaj
                <v-icon right dark>fas fa-print</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
      </v-row>

      <v-row v-if="!loading">
        <v-col cols="12" sm="10" md="12" id="workData" style="position:relative;">
          <div
            class="workTimeDropdown"
            style="display:flex;justify-content:space-between;align-items:center;"
            @click="showTableOne = !showTableOne">
            <h2>Prikaz prijav in odjav v izbranem obdobju</h2>
            <div>
              <v-icon @click.stop="printDetailedReport" color="green" style="margin-right:1rem;">fa-print</v-icon>
              <v-icon>fa-chevron-circle-down</v-icon>
            </div>
          </div>
          <v-simple-table
                v-show="showTableOne"
                fixed-header
                id="workTimeDataTable"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Datum prijave
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Uporabnik
                      </th>
                      <th class="text-left">
                        Čas prijave
                      </th>
                      <th class="text-left">
                        Blagajna prijave
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Datum odjave
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Čas odjave
                      </th>
                      <!-- <th class="text-left">
                        Odmor
                      </th> -->
                      <th class="text-left">
                        Blagajna odjave
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Stanje ob prijavi
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Stanje ob odjavi
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Razlika
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Promet gotovina
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Promet kartica
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Vrednost preklicanih miz
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Opravljenih ur
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody v-if="!loading">
                    <!-- {{ reportData }} -->
                    <template v-for="(dayDate) in reportData">
                      <!-- <tr :key="index"><td></td></tr> -->
                      <MyWorktimeRow
                        v-for="(dayData, index) in dayDate"
                        :key="index"
                        :dayData="dayData"
                        @refresh="refre"
                        @emitForm="setCurrentForm"
                      />
                    </template>
                  </tbody>
                </template>
            </v-simple-table>
        </v-col>
      </v-row>
      <v-row v-if="!loading">
        <v-col cols="12" sm="10" md="12" id="workData">
          <v-btn
                color="#0F998E"
                class="white--text mt-2 d-inlineblock"
                @click="setCurrentForm()"
              >
                Dodaj dogodek
                <!-- <v-icon right dark>fas fa-search</v-icon> -->
              </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!loading" style="margin-top:5rem;">
        <v-col cols="12" sm="10" md="12" id="workDataRange" style="position:relative;">
          <div
            class="workTimeDropdown"
            style="display:flex;justify-content:space-between;align-items:center;"
            @click="showTableTwo = !showTableTwo">
            <h2>Podatki uporabnikov v izbranem obdobju</h2>
            <div>
              <v-icon @click.stop="printSummaryReport" color="green" style="margin-right:1rem;">fa-print</v-icon>
              <v-icon>fa-chevron-circle-down</v-icon>
            </div>
          </div>
          <v-simple-table
            id="tableTwo"
            v-show="showTableTwo"
            fixed-header
              >
                <template v-slot:default>
                  <thead>
                    <tr style="border-bottom:1px solid #000;">
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Uporabnik
                      </th>
                      <th class="text-left">
                        Promet gotovina
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Promet kartica
                      </th>
                      <th class="text-left" v-if="!isMobile && !isSmallTablet">
                        Promet skupaj
                      </th>
                      <th class="text-center" v-if="!isMobile && !isSmallTablet">
                        Opravljenih ur
                      </th>
                      <th>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="!loading">
                    <MyWorktimeSummaryRow
                        v-for="(userReport, index) in reportDataSummary"
                        :key="index"
                        :userReport="userReport"
                      />
                  </tbody>
                </template>
            </v-simple-table>
        </v-col>
      </v-row>
    </div>

    <div class="print">
      <ReportPrintWorktime :data="reportData" :params="params" :reportDataSummary="reportDataSummary" v-if="reportData && reportDataSummary" />
    </div>

    <!-- {{ reportData }} -->
    <!-- {{ dateLastNextSessions }} -->

    <MyWorktimeNew
      v-if="currentForm !== null"
      :article="currentForm.form"
      :dateLastNextSessions="dateLastNextSessions"
      @refreshRepeat="refre"
      @zapri="currentForm = null; refre($event)"
    />
  </div>
</template>

<script>
// import moment from 'moment'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateSelector from '@/components/DateSelector'
import ReportPrintWorktime from '@/components/ReportPrintWorktime'
import MyWorktimeRow from '@/components/MyWorktimeRow'
import MyWorktimeNew from '@/pages/MyWorktimeNew'
import MyWorktimeSummaryRow from '@/components/MyWorktimeSummaryRow'

export default {
  components: {
    AppSpinner: () => import('@/components/AppSpinner'),
    ReportPrintWorktime,
    DateSelector,
    MyWorktimeRow,
    MyWorktimeNew,
    MyWorktimeSummaryRow
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      usersWithNull: [{ name: 'Vsi uporabniki', val: null }],
      user: null,
      reportData: [],
      reportDataSummary: [],
      dateLastNextSessions: {},
      loading: false,
      currentForm: null,
      startDate: '',
      startTime: '00:00:00',
      endDate: '',
      endTime: '23:59:00',
      showTableOne: true,
      showTableTwo: true
    }
  },
  computed: {
    users () {
      return Object.values(this.$store.state.users.items)
    },
    businessUnitCode () {
      return this.$store.state.businessUnits.currentBusinessUnit.business_premise_id
    },
    businessUnitId () {
      return this.$store.state.businessUnits.currentBusinessUnit.id
    },
    params () {
      return {
        startDate: this.startDate,
        startTime: this.startTime || '00:00:00',
        endDate: this.endDate,
        endTime: this.endTime || '23:59:59',
        user: this.user ? { id: this.user } : null,
        businessUniId: this.businessUnitId,
      }
    }
  },
  methods: {
    ...mapActions('users', { loadUsers: 'loadItems' }),
    ...mapActions('delovnicas', ['generirajPrikazDC','currentSessionWorkTime']),
    ...mapActions('reports', { getUserReport: 'user' }),
    setCurrentForm (details) {
      if (details) {
        this.currentForm = {
          form: { ...details }
        }
      } else {
        this.currentForm = {
          form: { ...details, id: null}
        }
      }
    },
    refre () {
      this.dateLastNextSessions = {}
      this.search()
    },
    async search () {
      this.loading = true
      this.reportData = []
      const response = await this.generirajPrikazDC(this.params)
      // const currentSessionWorkTime = await this.currentSessionWorkTime(this.params)
      // this.reportDataSummary = await this.getUserReport({ dateFrom: `${this.params.startDate}T00:00:00`, dateTo: `${this.params.endDate}T23:59:59`, businessUnit: this.businessUnitId, user: this.user })
      this.reportDataSummary = response.totals
      this.loading = false
      if (response) {
        // this.reportData = Object.values(response.data.items).sort((a, b) => a.date > b.date ? 1 : -1)
        // console.log('respss: ', response.daily.sort((a, b) => moment(a.start_time).valueOf() - moment(b.start_time).valueOf()))
        this.reportData = response.daily.sort((a, b) => moment(a.start_time).valueOf() - moment(b.start_time).valueOf()).reduce((sortedByDate, curr) => {
          var curDate = moment().format('DD.MM.YYYY')
          if (curr.start_time) {
            curDate = moment(curr.start_time.split('T')[0]).format('DD.MM.YYYY')
          } else {
            curDate = 'missing'
          }
          // console.log(curDate, yesterday, tomorrow)
          if (!sortedByDate[curDate]) {
            sortedByDate[curDate] = []
            curr = { ...curr, first: true, dateRow: curDate, yesterday: false, tomorrow: false, missingStartTime: curr.start_time }
          } else {
            curr = { ...curr, first: false, dateRow: curDate, yesterday: false, tomorrow: false, missingStartTime: curr.start_time }
          }
          sortedByDate[curDate].push(curr)
          return sortedByDate
        }, {})
      }
      // console.log({ ...this.reportData })
      /*
        NEED TO REFACTOR
        rabim prejsjo sejo odhoda
        rabim prihajajoco sejo prihoda
      */
      this.reportData  = Object.entries(this.reportData).map(([datem, value]) => {
        // const curDate = moment(datem).format('DD.MM.YYYY')
        const origiDateSplit = datem.split('.')
        const origiDate = `${origiDateSplit[2]}-${origiDateSplit[1]}-${origiDateSplit[0]}`
        const yesterday = moment(new Date(origiDate)).subtract(1, 'days').format('DD.MM.YYYY')
        const tomorrow = moment(new Date(origiDate)).add(1, 'days').format('DD.MM.YYYY')

        let lastSessionNumber = this.reportData[yesterday] && this.reportData[yesterday].length
        let nextSessionNumber = this.reportData[tomorrow] && this.reportData[tomorrow].length
        let currentSessionNumber = this.reportData[datem] && this.reportData[datem].length
        let lastSessionData = null
        let nextSessionData = null

        if (lastSessionNumber) {
          lastSessionData = {
            startTime: this.reportData[yesterday][lastSessionNumber - 1].start_time,
            stopTime: this.reportData[yesterday][lastSessionNumber - 1].stop_time
          }
          if (!this.dateLastNextSessions[origiDate]) {
            this.dateLastNextSessions[origiDate] = {
              lastSessionData: {}
            }
          }
          this.dateLastNextSessions[origiDate].lastSessionData = lastSessionData
        } else {
          // preverimo za 3 datume naprej cene je neumnost userja:
          // TERBA NRDIT SE ZA PREJSNJE NAJBLIZJE SEJE
          let counter = 10
          for (var i = 1; i <= counter; i++) {
            let otherDay = moment(new Date(origiDate)).subtract(i, 'days').format('DD.MM.YYYY')
            lastSessionNumber = this.reportData[otherDay] && this.reportData[otherDay].length
            // console.log(nextSessionNumber, this.reportData[otherDay], this.reportData, origiDate, otherDay, i)
            if (lastSessionNumber) {
              lastSessionData = {
                startTime: this.reportData[otherDay][lastSessionNumber - 1].start_time,
                stopTime: this.reportData[otherDay][lastSessionNumber - 1].stop_time
              }
              break
            }
          }
          if (!this.dateLastNextSessions[origiDate]) {
            this.dateLastNextSessions[origiDate] = {
              lastSessionData: {}
            }
          }
          this.dateLastNextSessions[origiDate].lastSessionData = lastSessionData
        }

        if (nextSessionNumber) {
          nextSessionData = {
            startTime: this.reportData[tomorrow][nextSessionNumber - 1].start_time,
            stopTime: this.reportData[tomorrow][nextSessionNumber - 1].stop_time
          }
          if (!this.dateLastNextSessions[origiDate]) {
            this.dateLastNextSessions[origiDate] = {
              nextSessionData: {}
            }
          }
          this.dateLastNextSessions[origiDate].nextSessionData = nextSessionData
        } else {
          // preverimo za 3 datume naprej cene je neumnost userja:
          // TERBA NRDIT SE ZA PREJSNJE NAJBLIZJE SEJE
          let counter = 10
          for (var i = 1; i <= counter; i++) {
            let otherDay = moment(new Date(origiDate)).add(i, 'days').format('DD.MM.YYYY')
            nextSessionNumber = this.reportData[otherDay] && this.reportData[otherDay].length
            // console.log(nextSessionNumber, this.reportData[otherDay], this.reportData, origiDate, otherDay, i)
            if (nextSessionNumber) {
              nextSessionData = {
                startTime: this.reportData[otherDay][nextSessionNumber - 1].start_time,
                stopTime: this.reportData[otherDay][nextSessionNumber - 1].stop_time
              }
              break
            }
          }
          this.dateLastNextSessions[origiDate].nextSessionData = nextSessionData
        }

        if (!this.dateLastNextSessions[origiDate]) {
          this.dateLastNextSessions[origiDate] = {
            currentSessionData: {}
          }
        }

        this.dateLastNextSessions[origiDate].currentSessionData = {
          startTime: this.reportData[datem][0].start_time,
          stopTime: this.reportData[datem][currentSessionNumber - 1].stop_time
        }

        return value.map((entry, index) => {
          entry = {
            ...entry
          }
          if (this.reportData[yesterday]) {
            entry.yesterday = true
          }
          if (this.reportData[tomorrow]) {
            entry.tomorrow = true
          }

          return entry
        })
      })/* .sort(([datema, a], [datemb, b]) => {
        return moment(datema).valueOf() - moment(datemb).valueOf()
      }) */
      /* this.reportData = this.reportData.map(date => {
        return date.map(entry => {
          const curDate = moment(entry.dateRow).format('DD.MM.YYYY')
          const yesterday = moment(curDate).subtract(1, 'days').format('DD.MM.YYYY')
          const tomorrow = moment(curDate).add(1, 'days').format('DD.MM.YYYY')
          entry = { ...entry, yesterday, tomorrow}
          return entry
        })
      }) */
      // console.log(userReportData)
        /* .catch(anErr => {
          alert(anErr)
          this.loading = false
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri generiranju izpisa.'
          })
        }) */
    },
    print () {
      // let routeData = this.$router.resolve({ name: 'MyCompanyReportsPrint', query: { params: JSON.stringify(this.params) } })
      // window.open(routeData.href, '_blank')
      window.print()
    },
    printDetailedReport () {},
    printSummaryReport () {},
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const today = moment().format('YYYY-MM-DD')
      // const todayEnd = moment().format('YYYY-MM-DDTHH:mm:ss')
      this.startDate = today
      this.endDate = today
      Promise.all([
        this.loadUsers()
      ])
        .then(response => {
          this.users.forEach(user => {
            let name = user.moniker
            if (user.complete_name) {
              name += ` - ${user.complete_name}`
            }
            this.usersWithNull.push({
              name,
              val: user.id
            })
          })
          this.asyncDataStatus_fetched()
          this.search()
        })
        .catch(anErr => {
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri nalaganju podatkov.'
          })
        })
    }
  },
  watch: {
    /* startDate: {
      handler (newVal) {
        if (newVal) this.search()
      },
      immediate: true
    },
    endDate (newVal) {
      if (newVal) this.search()
    },
    user (newVal) {
      this.search()
    } */
  }
}
</script>

<style lang="scss" scoped>
.print {
  display: none;
}
div.workTimeDropdown:hover {
  background-color: #0f998e1c;
  cursor: pointer;
}
::v-deep #workData > .v-menu__content {
  width: 100% !important;
  top: 70px !important;
}
::v-deep #workDataRange > .v-menu__content {
  width: 100% !important;
  top: 70px !important;
}
head > tr > * {
  border-bottom: 1px solid #000 !important;
}
td:empty::after {
  content: "\00a0";
}
::v-deep div#workDataRange table {
  border-collapse: collapse;
}
@media print {
  .print {
    display: block;
  }
}
</style>

<style lang="scss" scoped>
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
